<template>
  <div id="app">
    <Watermark
      :content="[
        '当前租户为试用租户',
        '到期后将自动删除数据',
        '试用完成后请及时续费',
      ]"
      v-if="showWatermark"
    />
    <!-- 这个style解决子元素滚动条滑动到边缘后外层滚动条继续滑动问题 -->
    <router-view style="overscroll-behavior-y: contain" />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (this.setMaskInterval) {
      this.setMaskInterval = null;
    }
    this.setMaskInterval = setInterval(() => {
      this.setMask();
    }, 1500);
  },
  data() {
    return {
      showWatermark: false,
      setMaskInterval: null,
    };
  },
  methods: {
    setMask() {
      if (
        !this.$storageUtil.getUserInfo() ||
        !this.$storageUtil.getAuthorityToken()
      ) {
        this.showWatermark = false;
        return;
      }
      let showWatermark = false;
      let whiteList = ["/", "/Login", "/404"];
      let curPath = this.$route.path;
      if (curPath && whiteList.indexOf(curPath) < 0) {
        let tenantSimplifiedPojo = this.$storageUtil.getTenantSimplifiedPojo();
        if (tenantSimplifiedPojo && tenantSimplifiedPojo.trialMark) {
          showWatermark = true;
        }
      }
      this.showWatermark = showWatermark;
    },
  },
};
</script>

<style lang="scss">
:root {
  --fm-primary-color: #409eff;
  --fm-primary-light-color: #f2f6fc;
  --fm-primary-lighter-color: #ecf5ff;

  --fm-success-color: #67c23a;
  --fm-success-light-color: #e1f3d8;
  --fm-success-lighter-color: #f0f9eb;

  --fm-warning-color: #e6a23c;
  --fm-warning-light-color: #faecd8;
  --fm-warning-lighter-color: #fdf6ec;

  --fm-danger-color: #f56c6c;
  --fm-danger-light-color: #fde2e2;
  --fm-danger-lighter-color: #fef0f0;

  --fm-error-color: #f56c6c;
  --fm-error-light-color: #fde2e2;
  --fm-error-lighter-color: #fef0f0;

  --fm-info-color: #909399;
  --fm-info-light-color: #e9e9eb;
  --fm-info-lighter-color: #f4f4f5;

  --fm-primary-text-color: #303133;
  --fm-regular-text-color: #606266;
  --fm-secondary-text-color: #909399;
  --fm-placeholder-color: #c0c4cc;

  --fm-border-color: #dcdfe6;
  --fm-border-light-color: #e4e7ed;
  --fm-border-lighter-color: #ebeef5;
  --fm-border-extralight-color: #f2f6fc;

  --fm-bg-color: #f5f5f5;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  min-width: 1280px;
  min-height: 600px;
}
* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/*全局滚动条样式*/
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  cursor: pointer;
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
.el-table__body-wrapper::-webkit-scrollbar {
  cursor: pointer;
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

/*
主要是靠这个 注意
上面.el-table__body-wrapper::-webkit-scrollbar 是 30px 下面这个也要 30px
*/
.el-scrollbar__wrap::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*全局滚动条样式结束*/

.el-table__fixed {
  height: 100% !important;
}
.el-table__fixed-right {
  height: 100% !important;
}

.el-divider--horizontal {
  margin: 10px 0;
}

.el-button [class*="el-icon-"] + span {
  margin-left: 0px !important;
}

/* 分页靠右 */
.el-pagination {
  text-align: right;
  padding-top: 10px;
}

.el-dialog__body > .el-tabs {
  margin-top: -30px;
}

.el-dropdown-menu__item .el-button {
  width: 100%;
  text-align: left;
}

img {
  image-rendering: -webkit-optimize-contrast;
}

.el-tooltip {
  cursor: pointer;
}

/* 解决切换分页会出现一个关闭图标 */
.hideclose .el-icon-circle-close {
  display: none !important;
}
.hideclose .el-icon-circle-check {
  display: none !important;
}

/* fmclass */
.fm {
  &-pointer {
    cursor: pointer;
  }

  &-link {
    cursor: pointer;
  }

  &-link:hover {
    text-decoration: underline;
  }

  &-unread:before {
    content: "● ";
    color: var(--fm-primary-color);
  }

  &-nowarp {
    text-wrap: nowrap;
  }

  @each $type in ("padding", "margin") {
    &-#{$type} {
      @each $direction in ("right", "left", "top", "bottom") {
        &-#{$direction} {
          @for $i from 0 through 200 {
            $size: $i * 5;

            &-#{$size} {
              #{$type}-#{$direction}: $size + px !important;
            }
          }
        }
      }

      @for $i from 0 through 200 {
        $size: $i * 5;

        &-#{$size} {
          #{$type}: $size + px !important;
        }
      }
    }
  }

  @each $abbr, $type in (m: "margin", p: "padding") {
    @each $dirAbbr, $direction in (t: "top", r: "right", b: "bottom", l: "left")
    {
      @for $i from 0 through 200 {
        $size: $i * 5;

        &-#{$abbr}#{$dirAbbr}-#{$size} {
          #{$type}-#{$direction}: $size + px !important;
        }
      }
    }

    @for $i from 0 through 200 {
      $size: $i * 5;

      &-#{$abbr}-#{$size} {
        #{$type}: $size + px !important;
      }
    }
  }

  &-relative,
  &-rela {
    position: relative !important;
  }

  &-absolute,
  &-abso {
    position: absolute !important;
  }

  &-flex {
    display: flex !important;
    flex-direction: row !important;
    justify-content: flex-start !important;
    align-items: center !important;
  }

  &-childflex {
    > * {
      display: flex !important;
      flex-direction: row !important;
      justify-content: flex-start !important;
      align-items: center !important;
    }
  }

  &-center {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
    justify-content: center !important;
  }

  &-aligncenter {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
  }

  &-justifycenter {
    display: flex !important;
    flex-direction: column;
    justify-content: center !important;
  }

  &-bgwhite {
    background-color: #ffffff;
  }

  &-width {
    @each $width in (50, 60, 70, 80, 90, 130, 180, 300) {
      &-#{$width} {
        width: $width + px !important;
      }
    }
  }

  &-clickable:active {
    opacity: 0.5;
  }

  &-line-1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1; /* 指定行数 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略号 */
    white-space: normal; /* 允许文本换行 */
    word-break: break-all;
  }
  &-line-2 {
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2; /* 指定行数 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略号 */
    white-space: normal; /* 允许文本换行 */
    word-break: break-all;
  }
  &-line-3 {
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 3; /* 指定行数 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略号 */
    white-space: normal; /* 允许文本换行 */
    word-break: break-all;
  }
  &-line-4 {
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 4; /* 指定行数 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略号 */
    white-space: normal; /* 允许文本换行 */
    word-break: break-all;
  }
  &-line-5 {
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 5; /* 指定行数 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略号 */
    white-space: normal; /* 允许文本换行 */
    word-break: break-all;
  }

  &-primary {
    color: #409eff;
  }

  &-success {
    color: #67c23a;
  }

  &-warning {
    color: #e6a23c;
  }

  &-danger {
    color: #f56c6c;
  }

  &-error {
    color: #f56c6c;
  }

  &-info {
    color: #909399;
  }

  &-bg {
    color: #f5f5f5;
  }

  // --fm-primary-text-color: #303133;
  // --fm-regular-text-color: #606266;
  // --fm-secondary-text-color: #909399;
  // --fm-placeholder-color: #c0c4cc;

  // --fm-border-color: #dcdfe6;
  // --fm-border-light-color: #e4e7ed;
  // --fm-border-lighter-color: #ebeef5;
  // --fm-border-extralight-color: #f2f6fc;
}

.fm-maintitle {
  font-size: 20px;
}

.fm-title {
  font-size: 18px;
}

.fm-subtitle {
  font-size: 16px;
}

.fm-content {
  font-size: 14px;
}

.orderprintremark {
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: pre-wrap !important; /* 保留空白符序列，但是正常地进行换行 */
}

.quantity_info {
  display: flex;
  justify-content: space-between;

  .column {
    display: flex;

    .title {
      text-align-last: justify;
    }

    .num {
      margin-left: 5px;
      div {
        height: 19.2px;
        display: flex;
        align-items: flex-end; /* 使子项在交叉轴上的终点对齐，即底部对齐 */
        justify-content: flex-end;
      }
    }
  }

  .watermark {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    pointer-events: none;
    user-select: none;
    opacity: 0.2; /* 调整透明度 */
    transform: rotate(-45deg); /* 调整旋转角度 */
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue